import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Shared by the create and edit geofence dialogs — when to alert, and on
// which of the two containment events. `activeDays: null` means "every
// day" (the default, and how a geofence behaves if nothing is touched
// here), not "no days" — an empty selection would silently turn a
// geofence's alerts off in a way that isn't obvious from the toggles above.
export function GeofenceScheduleFields({ form, setForm }) {
  const selectedDays = form.activeDays ?? [0, 1, 2, 3, 4, 5, 6];

  const toggleDay = (i) => {
    setForm((f) => {
      const current = f.activeDays ?? [0, 1, 2, 3, 4, 5, 6];
      const next = current.includes(i) ? current.filter((d) => d !== i) : [...current, i].sort();
      // Back to "every day" (null) once all seven are selected again, so a
      // geofence someone never touched here still reads as unrestricted.
      return { ...f, activeDays: next.length === 7 ? null : next };
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2.5 rounded-xl border border-border/60 bg-secondary/20 p-3.5">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-normal">Alert when entering</Label>
          <Switch checked={form.alertOnEnter} onCheckedChange={(v) => setForm((f) => ({ ...f, alertOnEnter: v }))} />
        </div>
        <div className="flex items-center justify-between">
          <Label className="text-sm font-normal">Alert when exiting</Label>
          <Switch checked={form.alertOnExit} onCheckedChange={(v) => setForm((f) => ({ ...f, alertOnExit: v }))} />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Active days</Label>
        <div className="grid grid-cols-7 gap-1">
          {DAYS.map((d, i) => (
            <button
              key={d}
              type="button"
              onClick={() => toggleDay(i)}
              data-testid={`geofence-day-${i}`}
              className={cn(
                "rounded-lg border py-1.5 text-xs font-medium transition",
                selectedDays.includes(i)
                  ? "border-primary/40 bg-primary/15 text-primary"
                  : "border-border/60 text-muted-foreground hover:text-foreground"
              )}
            >
              {d}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Start time</Label>
          <Input type="time" value={form.activeStartTime || ""} onChange={(e) => setForm((f) => ({ ...f, activeStartTime: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label>End time</Label>
          <Input type="time" value={form.activeEndTime || ""} onChange={(e) => setForm((f) => ({ ...f, activeEndTime: e.target.value }))} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">Leave times blank for all-day. Days and times are evaluated in UTC.</p>
    </div>
  );
}
